import { useEffect } from "react";

const NativeBanner = () => {
  useEffect(() => {
    const script = document.createElement("script");

    script.async = true;
    script.setAttribute("data-cfasync", "false");
    script.src =
      "https://pl30936313.effectivecpmnetwork.com/0bf552ea330fb447c59326e8555d38aa/invoke.js";

    const container = document.getElementById(
      "container-0bf552ea330fb447c59326e8555d38aa"
    );

    if (container) {
      container.appendChild(script);
    }

    return () => {
      if (container) {
        container.innerHTML = "";
      }
    };
  }, []);

  return (
    <div id="container-0bf552ea330fb447c59326e8555d38aa"></div>
  );
};

export default NativeBanner;